module.exports = __webpack_public_path__ + "img/a3.4613b56c.png";